exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mSZN3v-XqBmWbLsN27hX9{width:100%;min-height:80px;height:80px}.TpTeeUvfYvl_lVqn4LMwO{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}html[dir=ltr] ._1F96902FTldY8ViI3wMKTR{margin-right:8px}html[dir=rtl] ._1F96902FTldY8ViI3wMKTR{margin-left:8px}", ""]);
// Exports
exports.locals = {
	"container": "mSZN3v-XqBmWbLsN27hX9",
	"buttonContainer": "TpTeeUvfYvl_lVqn4LMwO",
	"button": "_1F96902FTldY8ViI3wMKTR"
};